export const DEPARTMENTS = [
  { key: 'clothing',    label: 'Clothing & Accessories',  emoji: '👕' },
  { key: 'jewelry',     label: 'Jewelry & Watches',       emoji: '💍' },
  { key: 'toys',        label: 'Toys & Games',            emoji: '🧸' },
  { key: 'electronics', label: 'Electronics & Gadgets',   emoji: '📱' },
  { key: 'home',        label: 'Home & Living',           emoji: '🛋️' },
  { key: 'books',       label: 'Books & Stationery',      emoji: '📚' },
  { key: 'art',         label: 'Art & Collectibles',      emoji: '🎨' },
  { key: 'essentials',  label: 'Health & Essentials',     emoji: '🧴' },
  { key: 'sports',      label: 'Sports & Outdoors',       emoji: '⚽' },
  { key: 'luggage',     label: 'Luggage & Travel',        emoji: '🧳' },
  { key: 'courses',     label: 'Courses & E-Books',       emoji: '🎓' },
  { key: 'gaming',      label: 'Gaming Items',            emoji: '🎮' },
  { key: 'vouchers',    label: 'Subscriptions & Vouchers',emoji: '🎟️' },
  { key: 'nft',         label: 'NFTs (Soon)',             emoji: '🖼️' },
];
export const DEPARTMENT_OTHER = { key: 'other', label: 'Other', emoji: '➕' };

export const keyToLabel = (key) => {
  const f = [...DEPARTMENTS, DEPARTMENT_OTHER].find(d => d.key === key);
  return f ? f.label : 'Other';
};
